<template>
  <v-card
    v-show="server.deleted === 'n' || userHasPermission('delete_server')"
    elevation="2"
  >
    <v-card-title>
      <v-sheet
        :color="setItemColour()"
        width="100%"
        class="overflow-hidden mt-n6 transition-swing"
        elevation="3"
        max-width="100%"
        rounded
      >
        <v-theme-provider
          dark
        >
          <div>
            <v-icon
              class="pa-2"
              v-text="setServerIcon()"
            />
            <span
              class="text-h6 white--text"
            >
              {{ server.Name }}
            </span>
          </div>
        </v-theme-provider>
      </v-sheet>
    </v-card-title>
    <v-card-text>
      <v-simple-table dense>
        <tbody>
          <tr>
            <td>Local IP</td>
            <td class="text-right">
              {{ server.private_ip_address }}
            </td>
          </tr>
          <tr>
            <td>Public IP</td>
            <td class="text-right">
              {{ server.external_ip_address }}
            </td>
          </tr>
          <tr>
            <td>Monitoring</td>
            <td class="text-right">
              <span
                v-for="monitor in serverMonitors"
                :key="monitor"
              >
                {{ monitor }}
              </span>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
    <v-card-actions
      v-if="adminToggle && server.deleted === 'n'"
    >
      <v-spacer />
      <deploy-dialog
        v-if="userHasPermission('deploy_service') && contract.redeploy_locked !== 'y' && server.server_type !== 'WIN' && server.server_type !== 'ITM' && server.server_type !== 'IMQ'"
        :server="server"
        :contract-name="contract.contract_name"
        :contract-number="contract.contract_number"
        @deployService="deployService"
      />
      <service-dialog
        v-if="userHasPermission('control_service') && contract.restart_locked !== 'y' && server.server_type !== 'WIN' && server.server_type !== 'ITM'"
        :server="server"
        :contract-name="contract.contract_name"
        :contract-number="contract.contract_number"
        @controlService="controlService"
      />
      <logs-dialog
        v-if="userHasPermission('view_logs') && server.server_type !== 'WIN' && server.server_type !== 'ITM'"
        :server="server"
        @downloadLogs="downloadLogs"
      />
      <thread-dump-dialog
        v-if="userHasPermission('thread_dump') && server.server_type !== 'WIN' && server.server_type !== 'ITM'"
        :server="server"
        :contract-name="contract.contract_name"
        :contract-number="contract.contract_number"
        @downloadThreadDump="downloadThreadDump"
      />
      <v-dialog
        v-if="userHasPermission('edit_server')"
        v-model="editDialog"
        persistent
        width="500"
      >
        <template v-slot:activator="{ on: dialog, attrs }">
          <v-tooltip
            top
            color="primary"
          >
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="{ ...tooltip, ...dialog }"
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
            </template>
            <span>Edit Server</span>
          </v-tooltip>
        </template>
        <v-card>
          <v-card-title class="text-h5 accent lighten-2">
            Edit {{ server.Name }}
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <v-form
                    ref="serverForm"
                  >
                    <v-text-field
                      v-model="localIP"
                      :rules="[rules.ip]"
                      label="Local IP Address"
                    />
                    <v-text-field
                      v-model="externalIP"
                      :rules="[rules.ip]"
                      label="External IP Address"
                    />
                    <v-subheader
                      v-if="server.server_type === 'CSR' || server.server_type === 'IMQ'"
                    >
                      Apps
                    </v-subheader>
                    <v-divider
                      v-if="server.server_type === 'CSR' || server.server_type === 'IMQ'"
                    />
                    <v-switch
                      v-if="server.server_type === 'CSR'"
                      v-model="reportsApp"
                      label="Install reports"
                    />
                    <v-switch
                      v-if="server.server_type === 'CSR'"
                      v-model="chatApp"
                      label="Install chat"
                    />
                    <v-switch
                      v-if="server.server_type === 'CSR'"
                      v-model="searchApp"
                      label="Install search"
                    />
                    <v-switch
                      v-if="server.server_type === 'CSR'"
                      v-model="assystaiApp"
                      label="Install assyst AI"
                    />
                    <v-switch
                      v-if="server.server_type === 'IMQ'"
                      v-model="ipaasApp"
                      label="Install ipaas"
                    />
                    <v-switch
                      v-if="server.server_type === 'IMQ'"
                      v-model="activemqApp"
                      label="Install activeMQ"
                    />
                    <v-subheader>
                      Monitoring
                    </v-subheader>
                    <v-divider></v-divider>
                    <v-switch
                      v-if="server.server_type === 'WEB'"
                      v-model="monitorAssyst"
                      label="Monitor assyst"
                    />
                    <v-switch
                      v-if="server.server_type === 'CSR'"
                      v-model="monitorReports"
                      label="Monitor reports"
                    />
                    <v-switch
                      v-if="server.server_type === 'CSR'"
                      v-model="monitorChat"
                      label="Monitor chat"
                    />
                    <v-switch
                      v-if="server.server_type === 'CSR'"
                      v-model="monitorSearch"
                      label="Monitor search"
                    />
                    <v-switch
                      v-if="server.server_type === 'CSR'"
                      v-model="monitorAssystAI"
                      label="Monitor assyst AI"
                    />
                    <v-switch
                      v-if="server.server_type === 'IMQ'"
                      v-model="monitorIpaas"
                      label="Monitor ipaas"
                    />
                    <v-switch
                      v-if="server.server_type === 'IMQ'"
                      v-model="monitorActiveMQ"
                      label="Monitor activeMQ"
                    />
                    <v-switch
                      v-model="monitorDAM"
                      label="Monitor ping"
                    />
                    <v-subheader
                      v-if="server.server_type === 'CSR'"
                    >
                      AI
                    </v-subheader>
                    <v-divider
                      v-if="server.server_type === 'CSR'"
                    />
                    <v-switch
                      v-if="server.server_type === 'CSR'"
                      v-model="usingAzureSearch"
                      label="Using Azure Search AI"
                    />
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-divider />

          <v-card-actions>
            <v-spacer />
            <v-btn
              text
              @click="cancelEdit()"
            >
              CANCEL
            </v-btn>
            <v-btn
              color="accent"
              @click="updateServer(server.Name, server.server_type, server.server_id)"
            >
              SAVE
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-if="userHasPermission('delete_server')"
        v-model="deleteDialog"
        persistent
        width="500"
      >
        <template v-slot:activator="{ on: dialog, attrs }">
          <v-tooltip
            top
            color="primary"
          >
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                color="red"
                icon
                v-bind="attrs"
                v-on="{ ...tooltip, ...dialog }"
              >
                <v-icon>mdi-delete-forever-outline</v-icon>
              </v-btn>
            </template>
            <span>Remove Server</span>
          </v-tooltip>
        </template>
        <v-card>
          <v-card-title class="text-h5 lighten-2">
            Warning!
          </v-card-title>

          <v-card-text>
            Are you sure you want to delete {{ server.Name }}?
          </v-card-text>

          <v-divider />

          <v-card-actions>
            <v-spacer />
            <v-btn
              text
              @click="deleteDialog = false"
            >
              CANCEL
            </v-btn>
            <v-btn
              color="red"
              dark
              @click="deleteServer(server.Name, server.server_type, server.server_id)"
            >
              DELETE
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-actions>
    <v-card-actions
      v-else-if="userHasPermission('delete_server') && adminToggle && server.deleted === 'y'"
    >
      <v-spacer />
      <v-dialog
        v-model="restoreDialog"
        persistent
        width="500"
      >
        <template v-slot:activator="{ on: dialog, attrs }">
          <v-tooltip
            top
            color="primary"
          >
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="{ ...tooltip, ...dialog }"
              >
                <v-icon>mdi-delete-restore</v-icon>
              </v-btn>
            </template>
            <span>Restore Server</span>
          </v-tooltip>
        </template>
        <v-card>
          <v-card-title class="text-h5 lighten-2">
            Restore?
          </v-card-title>

          <v-card-text>
            Are you sure you want to restore {{ server.Name }}?
          </v-card-text>

          <v-divider />

          <v-card-actions>
            <v-spacer />
            <v-btn
              text
              @click="restoreDialog = false"
            >
              CANCEL
            </v-btn>
            <v-btn
              color="accent"
              @click="restoreServer(server.Name, server.server_type, server.server_id)"
            >
              RESTORE
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-actions>
    <v-dialog
      v-model="deployResponse"
      max-width="1000"
      scrollable
      persistent
    >
      <v-card>
        <v-card-title class="text-h5 lighten-2">
          Deployment Logs
        </v-card-title>
        <v-card-text>
          <span
            v-for="(line, i) in deployMessage"
            :key="`log-${i}`"
            class="text-body-2"
          >
            {{ line.Value }} <br />
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="accent"
            @click="deployResponse = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay
      opacity="0.9"
      :value="overlay"
    >
      <v-container>
        <v-row
          class="fill-height"
          align-content="center"
          justify="center"
        >
          <v-col
            class="text-h4 text-center"
            cols="12"
          >
            {{ overlayMessage }}
          </v-col>
          <v-col cols="12">
            <v-progress-linear
              indeterminate
              rounded
              height="10"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-overlay>
  </v-card>
</template>

<script>
  import axios from 'axios'
  import { authHeader } from '@/util/helpers'
  import getEnv from '@/util/env'
  import { get, sync } from 'vuex-pathify'
  const host = getEnv('VUE_APP_API_HOST')
  export default {
    name: 'MaterialServerCard',
    props: {
      contract: Object,
      server: Object,
    },
    data () {
      return {
        editDialog: false,
        deleteDialog: false,
        restoreDialog: false,
        skipValidation: false,
        deployResponse: false,
        overlay: false,
        overlayMessage: '',
        deployMessage: '',
        externalIP: this.server.external_ip_address !== null ? this.server.external_ip_address : '',
        localIP: this.server.private_ip_address,
        deletedServer: this.server.deleted,
        reportsApp: this.server.reports === 'y',
        searchApp: this.server.search === 'y',
        chatApp: this.server.chat === 'y',
        assystaiApp: this.server.assystai === 'y',
        activemqApp: this.server.activemq === 'y',
        ipaasApp: this.server.ipaas === 'y',
        usingAzureSearch: this.server.using_azure_search_ai === 'y',
        monitorAssyst: this.server.monitor_assyst === 'y',
        monitorDAM: this.server.monitor_ping === 'y',
        monitorReports: this.server.monitor_reports === 'y',
        monitorChat: this.server.monitor_chat === 'y',
        monitorSearch: this.server.monitor_search === 'y',
        monitorAssystAI: this.server.monitor_assystai === 'y',
        monitorIpaas: this.server.monitor_ipaas === 'y',
        monitorActiveMQ: this.server.monitor_activemq === 'y',
        rules: {
          ip: value => {
            const pattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
            if (value) {
              return pattern.test(value) || 'Invalid IP address.'
            } else {
              return true
            }
          },
        },
      }
    },
    computed: {
      ...sync('app', [
        'adminToggle',
      ]),
      ...get('user', [
        'user'
      ]),
      serverData () {
        const fields = {
          external_ip_address: this.externalIP,
          private_ip_address: this.localIP,
          deleted: this.deletedServer,
          monitor_ping: this.monitorDAM === true ? 'y' : 'n',
        }
        switch (this.server.server_type) {
          case 'WEB':
            fields.monitor_assyst = this.monitorAssyst === true ? 'y' : 'n'
            break
          case 'CSR':
            fields.monitor_chat = this.monitorChat === true ? 'y' : 'n'
            fields.monitor_reports = this.monitorReports === true ? 'y' : 'n'
            fields.monitor_search = this.monitorSearch === true ? 'y' : 'n'
            fields.monitor_assystai = this.monitorAssystAI === true ? 'y' : 'n'
            fields.chat = this.chatApp === true ? 'y' : 'n'
            fields.reports = this.reportsApp === true ? 'y' : 'n'
            fields.search = this.searchApp === true ? 'y' : 'n'
            fields.assystai = this.assystaiApp === true ? 'y' : 'n'
            fields.using_azure_search_ai = this.usingAzureSearch === true ? 'y' : 'n'
            break
          case 'IMQ':
            fields.monitor_ipaas = this.monitorIpaas === true ? 'y' : 'n'
            fields.monitor_activemq = this.monitorActiveMQ === true ? 'y' : 'n'
            fields.ipaas = this.ipaasApp === true ? 'y' : 'n'
            fields.activemq = this.activemqApp === true ? 'y' : 'n'
            break
          default:
            break
        }
        return fields
      },
      serverMonitors () {
        const monitors = []
        if (this.server.monitor_assyst === 'y') {
          monitors.push('Web')
        }
        if (this.server.monitor_reports === 'y') {
          monitors.push('Reports')
        }
        if (this.server.monitor_search === 'y') {
          monitors.push('Search')
        }
        if (this.server.monitor_chat === 'y') {
          monitors.push('Chat')
        }
        if (this.server.monitor_assystai === 'y') {
          monitors.push('Assyst AI')
        }
        if (this.server.monitor_ipaas === 'y') {
          monitors.push('iPaaS')
        }
        if (this.server.monitor_activemq === 'y') {
          monitors.push('ActiveMQ')
        }
        if (this.server.monitor_ping === 'y') {
          monitors.push('Ping')
        }
        return monitors
      },
      serverFormValid () {
        if (this.$refs.serverForm) {
          return this.$refs.serverForm.validate()
        } else {
          return false
        }
      },
    },
    methods: {
      userHasPermission: function (perm) {
        let perms = this.user.permissions.map(a => a.name)
        return perms.includes(perm)
      },
      deleteServer: function (serverName, serverType, serverId) {
        this.deletedServer = 'y'
        this.deleteDialog = false
        this.skipValidation = true
        this.updateServer(serverName, serverType, serverId)
      },
      updateServer: function (serverName, serverType, serverId) {
        if (this.serverFormValid || this.skipValidation) {
          axios
            .put(
              `${host}/v2/servers/${serverType.toLowerCase()}/${serverId}`,
              this.serverData,
              {
                headers: authHeader(),
              },
            ) // eslint-disable-next-line
            .then((response) => {
              this.$snackbar.showMessage({ content: serverName + ' has been updated.', color: 'success', timeout: 5000 })
              this.editDialog = false
              this.skipValidation = false
              setTimeout(() => this.$emit('updateServer'), 1000)
            })
            .catch((err) => {
              var message = ''
              if (err.response.status === 401) {
                message = 'You do not have permission to perform this action.'
              } else {
                message = 'There was an error, please try again.'
              }
              this.$errordialog.showMessage({ content: message, color: 'error', title: 'Oops! Something went wrong.' })
              this.editDialog = false
              this.skipValidation = false
            })
        }
      },
      restoreServer: function (serverName, serverType, serverId) {
        this.deletedServer = 'n'
        this.restoreDialog = false
        this.skipValidation = true
        this.updateServer(serverName, serverType, serverId)
      },
      cancelEdit: function () {
        this.localIP = this.server.private_ip_address !== null ? this.server.private_ip_address : ''
        this.externalIP = this.server.external_ip_address !== null ? this.server.external_ip_address : ''
        this.monitorAssyst = this.server.monitor_assyst === 'y'
        this.monitorDAM = this.server.monitor_ping === 'y'
        this.monitorReports = this.server.monitor_reports === 'y'
        this.monitorChat = this.server.monitor_chat === 'y'
        this.monitorSearch = this.server.monitor_search === 'y'
        this.monitorAssystAI = this.server.monitor_assystai === 'y'
        this.monitorIpaas = this.server.monitor_ipaas === 'y'
        this.monitorActiveMQ = this.server.monitor_activemq === 'y'
        this.reportsApp = this.server.reports === 'y',
        this.searchApp = this.server.search === 'y',
        this.chatApp = this.server.chat === 'y',
        this.assystaiApp = this.server.assystai === 'y',
        this.activemqApp = this.server.activemq === 'y',
        this.ipaasApp = this.server.ipaas === 'y',
        this.usingAzureSearch = this.server.using_azure_search_ai === 'y',
        this.editDialog = false
      },
      downloadLogs: function (logpath, logfile) {
        this.overlayMessage = 'Getting your file'
        this.overlay = !this.overlay
        axios
          .post(
            `${host}/actions/logs`,
            {
              data: {
                server_ip: this.localIP,
                server_name: this.server.Name,
                logpath: logpath,
                logfile: logfile,
              },
            },
            {
              headers: authHeader(),
              responseType: 'blob',
            },
          )
          .then(response => {
            let filename = this.server.Name + '-logs.tar.gz'
            filename = decodeURI(filename)
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            window.URL.revokeObjectURL(url)
            link.remove()
            this.overlay = !this.overlay
          })
          .catch(err => {
            err.response.data.text().then(blob => {
              const error = JSON.parse(blob)
              var message = error.error !== undefined ? error.error : err.message
              this.$errordialog.showMessage({ content: message, color: 'error', title: 'Oops! Something went wrong.' })
              this.overlay = !this.overlay
            })
          })
      },
      downloadThreadDump: function (serviceObject) {
        this.overlayMessage = 'Getting your file'
        this.overlay = !this.overlay
        axios
          .post(
            `${host}/actions/threaddump`,
            serviceObject,
            {
              headers: authHeader(),
              responseType: 'blob',
            },
          )
          .then(response => {
            let date = new Date()
            let filename = this.server.Name + '-' + serviceObject.data.service_name + '-threaddump-' + date.toISOString() + '.txt'
            filename = decodeURI(filename)
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            window.URL.revokeObjectURL(url)
            link.remove()
            this.overlay = !this.overlay
          })
          .catch(err => {
            err.response.data.text().then(blob => {
              const error = JSON.parse(blob)
              var message = error.error !== undefined ? error.error : err.message
              this.$errordialog.showMessage({ content: message, color: 'error', title: 'Oops! Something went wrong.' })
              this.overlay = !this.overlay
            })
          })
      },
      controlService: function (serviceObject) {
        this.overlayMessage = 'Please wait'
        this.overlay = !this.overlay
        axios
          .post(
            `${host}/actions/service`,
            serviceObject,
            {
              headers: authHeader(),
            },
          ) // eslint-disable-next-line
          .then(response => {
            this.overlay = !this.overlay
            this.$snackbar.showMessage({ content: 'The attempt to ' + serviceObject.data.service_action + ' ' + serviceObject.data.service_name + ' was successful.', color: 'success', timeout: 5000 })
          })
          .catch(err => {
            console.log(err)
            this.overlay = !this.overlay
            this.$errordialog.showMessage({ content: 'There was an error, please try again.', color: 'error', title: 'Oops! Something went wrong.' })
          })
      },
      deployService: function (serviceObject) {
        this.overlayMessage = 'Please wait'
        this.overlay = !this.overlay
        axios
          .post(
            `${host}/actions/deploy`,
            serviceObject,
            {
              headers: authHeader(),
            },
          ) // eslint-disable-next-line
          .then(response => {
            this.overlay = !this.overlay
            this.deployResponse = true
            this.deployMessage = response.data.logs
            this.$snackbar.showMessage({ content: 'The attempt to ' + serviceObject.data.service_action + ' ' + serviceObject.data.service_name + ' was successful.', color: 'success', timeout: 5000 })
          })
          .catch(err => {
            console.log(err)
            this.overlay = !this.overlay
            this.$errordialog.showMessage({ content: 'There was an error, please try again.', color: 'error', title: 'Oops! Something went wrong.' })
          })
      },
      setItemColour: function () {
        if (this.server.deleted === 'y') {
          return 'grey'
        } else {
          return 'accent'
        }
      },
      setServerIcon: function () {
        if (this.server.deleted === 'y') {
          return 'mdi-server-off'
        } else {
          return 'mdi-server'
        }
      },
    },
  }
</script>

<style>

</style>
